import { Button } from "antd"
import React from "react"

import Icon from "../../../Icon"
import { ActionTooltip } from "../../../components/ActionTooltip.tsx"
import { unavailableProps } from "../../../utils/unavailable-control.ts"
import { isInvoiceEditable } from "../helpers/invoice-lifecycle.ts"
import { INVOICE_STATUSES } from "../types/invoices.types.ts"

type Translate = (key: string, options?: Record<string, unknown>) => string

interface InvoiceEditButtonProps {
  record: {
    status?: number | null
    origin?: number | null
    is_generated?: boolean
    is_editable?: boolean
  }
  t: Translate
  /** Another row is open for edit; the table is locked, not this invoice. */
  disabled?: boolean
  onEdit: () => void
}

/**
 * The pencil beside a row's "⋯". A generated invoice that has been issued is
 * a document the customer holds, so the pencil stays in place and says why it
 * does nothing rather than disappearing.
 */
export function InvoiceEditButton({
  record,
  t,
  disabled = false,
  onEdit
}: InvoiceEditButtonProps) {
  const editable = isInvoiceEditable(record)
  const title = editable
    ? t("invoices.actions.edit")
    : record.status === INVOICE_STATUSES.VOID
      ? t("invoices.editLocked.voided")
      : t("invoices.editLocked.generated")

  // The row underneath opens the record on click.
  const unavailable = unavailableProps(!editable || disabled, (event) => {
    event.stopPropagation()
    onEdit()
  })

  return (
    <ActionTooltip title={title}>
      <Button
        {...unavailable}
        aria-label={title}
        data-testid="invoice-edit-button"
        icon={<Icon type="Edit" />}
      />
    </ActionTooltip>
  )
}
